import React from 'react'
import Link from 'components/Link'
import { DEFAULT_ACCENT } from '../../../utils/constants'
import classNames from 'classnames'

const PageContentTabs = ({ color = DEFAULT_ACCENT, tabs, noMargin }) => {

  return (
    <div className={classNames(`secondary-nav secondary-nav_${color}`, noMargin && 'secondary-nav--no-margin')}>
      {tabs?.length > 0 && tabs.map((tab, index) => tab.to ?
        <Link
          key={index}
          to={tab.to}
          onClick={tab.onClick}
          className={classNames('secondary-nav__link', tab.active && 'secondary-nav__link_active')}
        >
          {tab.label}
        </Link>
        : 
        <button
          key={index}
          onClick={tab.onClick}
          className={classNames('secondary-nav__link', tab.active && 'secondary-nav__link_active')}
        >
          {tab.label}
        </button>
      )}
    </div>
  )
}

export default PageContentTabs